import type { MediaLibraryItem } from "@/types";

/** "12 Aug 2026" — compact, locale-stable for the details panel + list view. */
export function formatMediaDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}

/** "800 × 600" when both dimensions are known, otherwise a dash. */
export function dimensionLabel(item: MediaLibraryItem): string {
  if (!item.width || !item.height) return "—";
  return `${item.width} × ${item.height}`;
}

/** Short, human file type ("JPEG", "PNG", "WEBP") derived from mime / name. */
export function fileKind(item: MediaLibraryItem): string {
  const fromMime = item.mime.split("/")[1];
  if (fromMime) return fromMime.toUpperCase().replace("SVG+XML", "SVG");
  const ext = item.fileName.split(".").pop();
  return ext ? ext.toUpperCase() : "FILE";
}

/** True when the item can be shown inline as an <img>. */
export function isImage(item: MediaLibraryItem): boolean {
  if (item.mime.startsWith("image/")) return true;
  return /\.(jpe?g|png|gif|webp|avif)$/i.test(item.fileName);
}